//
// Copyright 2023 DXOS.org
//

export const sum = (values: number[]) => values.reduce((a, b) => a + b, 0);
